import { render, staticRenderFns } from "./OrdersManager.vue?vue&type=template&id=896d2fc0"
import script from "./OrdersManager.vue?vue&type=script&lang=js"
export * from "./OrdersManager.vue?vue&type=script&lang=js"
import style0 from "./OrdersManager.vue?vue&type=style&index=0&id=896d2fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports